import {makeStyles} from '@material-ui/core/styles';

export default makeStyles({
	card: {
	    display: 'flex',
		flexDirection: 'column',
		justifyContent: 'space-between',
		alignItems: 'center',
		width: '100%',
		height: '60vh',
		padding: '10%',
		borderRadius: 10,
		color: 'white',
	},
	infoCard: {
		display: 'flex', 
		flexDirection: 'column', 
		textAlign: 'center',
	},
	container: {
		padding: '0 5%',
		margin: '0',
		width: '100%',
		
	}
})